import { Record } from "@deepstream/client/dist/src/record/record";
import axios from "axios";

export default class Preview {
  constructor(deepstream, store) {
    this.store = store;
    this.deepstream = deepstream;
    /**
     * @type {Record}
     */
    this.record = null;
    this.meeting = null;
  }
  async join(recordName) {
    this.record = this.deepstream.client.record.getRecord(recordName);
    await this.record.whenReady();
    this.record.unsubscribe();
    this.record.setMergeStrategy(
      (record, localVersion, remoteValue, remoteVersion, callback) => {
        callback(null, record);
      }
    );
    this.unsubscribe();
    this.meeting = await this.record.get();
    if (!this.meeting) {
      throw new Error("Session no longer active");
    }
    this.subscribe();
  }

  subscribe() {
    // subscribe session status
    this.record.subscribe(
      "sync.currentInteractionState",
      this.syncCurrentInteractionState.bind(this),
      true
    );

    //subscribe currentInteraction
    this.record.subscribe(
      "sync.currentInteraction",
      this.syncCurrentInteraction.bind(this),
      true
    );

    //subscribe standby
    this.record.subscribe("sync.standby", this.syncStandby.bind(this), true);
  }

  unsubscribe() {
    this.record.unsubscribe(
      "sync.currentInteractionState",
      this.syncCurrentInteractionState.bind(this)
    );

    this.record.unsubscribe(
      "sync.currentInteraction",
      this.syncCurrentInteraction.bind(this)
    );

    this.record.unsubscribe("sync.standby", this.syncStandby.bind(this));
  }

  syncCurrentInteractionState(state) {
    this.store.commit("preview/currentInteractionState", state);
  }

  async syncCurrentInteraction(currentInteraction) {
    if (currentInteraction?.source === "plugin") {
      await this.setCurrentInteractionFormatVersion1(currentInteraction);
      return;
    }

    if (this.meeting?.cardsVersion === 2) {
      await this.setCurrentInteractionFormatVersion2(currentInteraction);
      return;
    }

    await this.setCurrentInteractionFormatVersion1(currentInteraction);
  }

  syncStandby(standby) {
    this.store.commit("meeting/standby", standby);
  }

  async setCurrentInteractionFormatVersion1(currentInteraction) {
    this.store.commit("meeting/currentInteraction", currentInteraction);
  }

  async setCurrentInteractionFormatVersion2(currentInteraction) {
    if (!currentInteraction) {
      this.store.commit("meeting/currentInteraction", null);
      return;
    }

    if (
      currentInteraction.type === "card" &&
      !currentInteraction?.content?.hash_id
    ) {
      this.store.commit("meeting/currentInteraction", null);
      return;
    }

    if (currentInteraction.type !== "card") {
      this.store.commit("meeting/currentInteraction", currentInteraction);
      return;
    }

    const response = await axios.post(
      `${process.env.CORE_DATA_SERVICES_API_URL}/cards/getCard`,
      { hash_ids: currentInteraction.content.hash_id }
    );
    this.store.commit("meeting/currentInteraction", {
      ...currentInteraction,
      content: response.data,
    });
  }

  async cardStateChanged(state) {
    await this.record.set("sync.currentInteractionState", state);
  }

  async logout() {
    this.store.commit("meeting/reset");
    this.deepstream.logout();
    document.location = "/widget";
  }
}
